import { InvestmentGroup, InvestmentGroupApi } from '../interfaces/channel';

export default (data: InvestmentGroupApi[]): InvestmentGroup[] => {
  return data.flat().map(item => ({
    campaigns: item.campaigns,
    campaignsId: item.campaigns_id,
    investmentGroup: item.investment_group,
  }));
};
